import React from 'react';

import TabPanel from '@mui/lab/TabPanel';

import { DxUpdate } from '../';

import {
  scrollTabPanelSx
} from './SoapLeftStyles';

const DiagnosisTabPanel = () => {
  return (
    <TabPanel
      value="3"
      sx={scrollTabPanelSx}>
      <DxUpdate />
    </TabPanel>
  );
};

export default DiagnosisTabPanel;